import {Component, OnInit} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {Sort} from '@angular/material/sort';
import {saveAs} from 'file-saver';
import {InvoiceOverviewDTO} from '../../../../model/invoiceOverviewDTO';
import {InvoiceService} from '../../../../services/invoice.service';
import {CurrencyService} from '../../../../services/currency-service';
import {NotificationService} from '../../../../services/notification.service';

@Component({
  templateUrl: './invoice-overview.component.html',
})
export class InvoiceOverviewComponent implements OnInit {

  content: InvoiceOverviewDTO[] = [];
  totalElements = 0;
  sort;

  pageSize = 250;
  pageSizeOptions: number[] = [25, 50, 100, 250, 500, 1000];
  pageEvent: PageEvent = new PageEvent(); // MatPaginator Output


  constructor(private service: InvoiceService,
              public currencyService: CurrencyService,
              private notificationService: NotificationService) {
  }

  ngOnInit() {
    this.sort = {column: 'year,invoiceNumber', dir: 'desc'};
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.getPage();
  }

  updatePage($event) {
    this.pageEvent = $event;
    this.getPage();
    return $event;
  }

  getPage() {
    this.service.getAll(this.pageEvent.pageIndex, this.pageEvent.pageSize, this.sort.column, this.sort.dir).subscribe(page => {
      this.content = page.content;
      this.totalElements = page.totalElements;
    });
  }

  sortPage($event: Sort) {
    this.sort.column = $event.active;
    this.sort.dir = $event.direction;
    this.getPage();
  }

  download(row: InvoiceOverviewDTO) {
    this.service.download(row.id).subscribe(data => {
      saveAs(data, row.invoiceNumber + ' ' + row.user + '.pdf');
      this.notificationService.success('Factuur gedownload');
    });
  }
}
